/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Icon, Text, Theme, Tooltip, useTheme } from 'bold-ui'
import { formatDate } from 'util/date/formatDate'

interface RetificacaoAtendimentoStatusProps {
  status: 'Removido' | 'Editado'
  data: Instant
}

export function RetificacaoAtendimentoStatus(props: Readonly<RetificacaoAtendimentoStatusProps>) {
  const { status, data } = props

  const tooltipText = `${status} em ${formatDate(data)}`

  const theme = useTheme()
  const style = createStyles(theme)

  return (
    <Tooltip text={tooltipText}>
      <HFlow hSpacing={0.5} style={style.container}>
        <Icon icon='infoCircleOutline' size={1} />
        <Text color='inherit'>{status}</Text>
      </HFlow>
    </Tooltip>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    color: ${theme.pallete.primary.main};
    align-items: center;
  `,
})
